import React, { useState, useEffect } from "react"
import Cat from "../../assets/Cat.svg"
import ModalContainer from "../../components/ModalContainer/ModalContainer"
import DashboardNavbar from "../../components/Navbar/DashboardNavbar"
import { createEvent } from "../../utils/ApiRequests"
import FullLoader from "../../components/Loaders/FullLoader"
import { getApiErrorMessage, Today } from "../../utils/ApiUtils"
import { useToasts } from "react-toast-notifications"
import { useEvent } from "../../context/EventContext"
import { getEventTypes } from "../../utils/ApiRequests"
import ProgressBar from "../../components/ProgressBar/ProgressBar"
const EventPage1 = ({ formStep }) => {
  const [showModal, setShowModal] = useState(false)
  const [eventTypes, setEventTypes] = useState([])
  const [eventType, setEventType] = useState("")
  const [loading, setLoading] = useState(false)
  const [giftType, setGiftType] = useState("")
  const [form, setForm] = useState({})
  const [eventTypeQuestion, setEventTypeQuestion] = useState()
  const [qA, setQA] = useState({})
  const { addToast } = useToasts()
  const { setCurrentEvent } = useEvent()

  useEffect(() => {
    getEventTypes()
      .then(res => {
        setLoading(false)
        setEventTypes(res.data?.data)
      })
      .catch(err => {
        addToast("Please check your internet connection", {
          appearance: "error",
          autoDismiss: true
        })
      })
  }, [addToast])

  console.log(eventTypes)

  const giftTpes = [
    {
      title: "Cash",
      value: "CASH"
    },
    {
      title: "Gift",
      value: "GIFT"
    },
    {
      title: "Gift and Cash",
      value: "GIFT_AND_CASH"
    }
  ]

  const handleChange = e => {
    const name = e.target.name
    const value = e.target.value
    const newEntry = { [name]: value }
    setForm({ ...form, ...newEntry })
  }

  const handleQuestions = e => {
    const name = e.target.name
    const value = e.target.value
    const newEntry = { [name]: value }
    setQA({ ...qA, ...newEntry })
  }

  const postEvent = e => {
    e.preventDefault()
    if (!eventType) {
      addToast("Please select an event type", {
        appearance: "error",
        autoDismiss: true
      })
      return null
    }

    setLoading(true)

    createEvent({
      event_type: eventType,
      end_date: form.date,
      start_date: form.date,
      event_owners_name: form.name,
      name: form.name,
      questions: qA
    })
      .then(res => {
        setLoading(false)
        setShowModal(true)
        setCurrentEvent(res.data?.data?._id)
      })
      .catch(err => {
        setLoading(false)
        addToast(getApiErrorMessage(err.response), {
          appearance: "error",
          autoDismiss: true
        })
      })
  }

  console.log({
    event_type: eventType,
    end_date: form.date,
    start_date: form.date,
    event_owners_name: form.name,
    name: form.name,
    questions: qA
  })
  return (
    <>
      <section className="relative min-h-screen">
        {showModal && (
          <ModalContainer>
            <div className=" py-8 px-10 bg-sbg-white max-w-4xl">
              <p className="mb-5 text-center text-grey">
                We have successfully created your event. Let’s get started with
                setting up your event registry.
              </p>

              <button
                className="mx-auto block bg-sbg-light-green px-16 py-3 text-center text-white rounded-md focus:outline-none medium:px-8 "
                onClick={() => {
                  setShowModal(false)
                  formStep(2)
                }}
              >
                Create registry
              </button>
            </div>
          </ModalContainer>
        )}

        {loading && <FullLoader />}

        <DashboardNavbar />

        <form
          className="global-container pt-24 mx-auto relative z-10 flex flex-col justify-center items-center"
          onSubmit={postEvent}
        >
          <ProgressBar selected={1} />
          <h5 className="font-bold self-start w-8/12 mx-auto text-2xl text-grey my-10 medium:text-center">
            Create event
          </h5>
          {/* End of Title Block */}

          {/* Entry One for the event page  */}

          <div className="w-8/12 medium:w-full mb-10">
            <div className="flex justify-between w-full">
              <div className="border border-sbg-grey h-12 w-12 rounded-full flex items-center justify-center">
                <h1 className="text-grey">1</h1>
              </div>

              <div className="w-10/12 ">
                <h1 className="text-grey text-xl ">Select the event type</h1>
                <p className="text-grey text-sm my-1.5 ">
                  Choose the category that matches your event. If your event is
                  not listed, kindly select others for more options.
                </p>
              </div>
            </div>
            <div className="w-5/6 ml-auto flex flex-wrap medium:w-full medium:justify-center">
              {eventTypes.map(event => (
                <div
                  key={event._id}
                  className={`w-1/4 py-6 ${
                    eventType === event._id ? "bg-white" : "bg-sbg-light-grey"
                  } border border-sbg-light-grey-2 flex justify-center items-center flex-col medium:w-32 cursor-pointer`}
                  onClick={() => {
                    setEventType(event._id)
                    setEventTypeQuestion(event)
                  }}
                >
                  <img
                    src={event.icon_image}
                    alt="package icon"
                    className="h-20"
                  />
                  <h2 className="mt-3 text-grey">{event?.name}</h2>
                </div>
              ))}
            </div>
          </div>

          {/* End of entry one the event page */}

          <div className="w-8/12 medium:w-full mb-10">
            <div className="flex justify-between w-full">
              <div className="border border-sbg-grey h-12 w-12 rounded-full flex items-center justify-center ">
                <h1 className="text-grey">2</h1>
              </div>

              <div className="w-10/12 ">
                <h1 className="text-grey text-xl ">
                  When is your Special day?
                </h1>
                <p className="text-grey text-sm my-1.5 ">
                  Select the date of your event
                </p>
              </div>
            </div>
            <div className="py-6 px-10 medium:px-6 bg-sbg-light-grey w-5/6 ml-auto flex flex-wrap medium:w-full medium:justify-center ">
              <input
                placeholder="Enter your partner's name"
                className="w-full py-4 px-3 focus:outline-none text-grey"
                type="date"
                name="date"
                min={Today()}
                required
                onChange={handleChange}
              />
            </div>
          </div>

          {!!eventTypeQuestion && (
            <>
              <div className="w-8/12 medium:w-full mb-10">
                <div className="flex justify-between w-full">
                  <div className="border border-sbg-grey h-12 w-12 rounded-full flex items-center justify-center">
                    <h1 className="text-grey">3</h1>
                  </div>

                  <div className="w-10/12 ">
                    <h1 className="text-grey text-xl ">
                      Name of the celebrant
                    </h1>
                    {/* <p className="text-grey text-sm my-1.5 ">
                        Tell us about your partner
                      </p> */}
                  </div>
                </div>

                <div className="py-6 px-10 medium:px-6 bg-sbg-light-grey w-5/6 ml-auto flex flex-wrap medium:w-full medium:justify-center ">
                  <input
                    placeholder="Celebrant's name"
                    name="name"
                    className="w-full py-4 px-3 focus:outline-none text-grey"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {eventTypeQuestion?.questions?.map((q, i) => (
                <div className="w-8/12 medium:w-full mb-10">
                  <div className="flex justify-between w-full">
                    <div className="border border-sbg-grey h-12 w-12 rounded-full flex items-center justify-center">
                      <h1 className="text-grey">{4 + i}</h1>
                    </div>

                    <div className="w-10/12 ">
                      <h1 className="text-grey text-xl ">{q}</h1>
                      {/* <p className="text-grey text-sm my-1.5 ">
                        Tell us about your partner
                      </p> */}
                    </div>
                  </div>

                  <div className="py-6 px-10 medium:px-6 bg-sbg-light-grey w-5/6 ml-auto flex flex-wrap medium:w-full medium:justify-center ">
                    <input
                      placeholder={q}
                      name={q}
                      className="w-full py-4 px-3 focus:outline-none text-grey"
                      value={form.q}
                      onChange={handleQuestions}
                      required
                    />
                  </div>
                </div>
              ))}
            </>
          )}

          <div className="w-8/12 medium:w-full">
            <button
              className="my-10 mx-auto block bg-sbg-light-green px-16 py-3 text-center text-white rounded-md focus:outline-none"
              type="submit"
            >
              Create event
            </button>
          </div>
        </form>
      </section>
    </>
  )
}

export default EventPage1
